"use strict";

var languageService = angular.module('service.Language', []);

languageService.factory('languageService', ['$translate', '$rootScope', 'tmhDynamicLocale', 'halClient', 'appSettings', 'datepickerPopupConfig',
    function ($translate, $rootScope, tmhDynamicLocale, halClient, appSettings, datepickerPopupConfig) {

        var languagesUrl = appSettings.apiBaseUri + "/user/languages";
        var currentLocale ;

        var setLocale = function (locale) {
            currentLocale = locale;
            $translate.use(locale);
        };

    $rootScope.$on('$translateChangeSuccess', function (event, data) {
        document.documentElement.setAttribute('lang', data.language);// sets "lang" attribute to html
        tmhDynamicLocale.set(data.language.toLowerCase().replace(/_/g, '-'));
        datepickerPopupConfig.currentText = $translate.instant('label.datePicker.currentText');
        datepickerPopupConfig.clearText = $translate.instant('label.datePicker.clearText');
        datepickerPopupConfig.closeText = $translate.instant('label.datePicker.closeText');
    });

    return {
        setLocaleByDisplayName: function (localeDisplayName) {
            setLocale(localeDisplayName);
        },
        getLocalesDisplayNames: function (username) {
            return halClient.$get(languagesUrl + "?username=" + username);
        }
    };
}]);